const dev = {
  API_PORTAL: "api-sandbox.algartelecom.com.br",
  API_SENSEDIA_CLIENT_ID: "4a8d990d-934d-3f6a-8092-967eb7f4026f",
  API_SENSEDIA_CORP: "api-sandbox.algartelecom.com.br",
  API_SENSEDIA_BASIC:
    "Basic NGE4ZDk5MGQtOTM0ZC0zZjZhLTgwOTItOTY3ZWI3ZjQwMjZmOmY2MWFkNGE4LTg4ODAtMzljYS04NjE1LTkyZTljNmRhZjM5NQ==",
  API_SHARED_DATA: "https://compartilhamentohml.algar.com.br/callback",
  API_CUSTOMER_IDENTITY: "https://customeridentity-hml.algar.com.br/auth",
  SVA_LINK: "https://dev.algar.atendimentosva.com.br",
  SVA_DATA:
    '{ "username": "algarppaapi", "password": "Yk3jyDMXPaGPLSneChVYxHqpt6PQbHqVskN47pCa", "grant_type": "password", "scope": "read", "msisdn": "5521998550019" }',
  BFF: "https://gateway-hml.algartelecom.com.br",
  URL_NEW_B2B: "https://portaldeclienteshml.algar.com.br"
}

const prd = {
  API_PORTAL: "api-portal.algartelecom.com.br",
  API_SENSEDIA_CLIENT_ID: "247471e4-054e-3597-acf0-b5fb250e36c3",
  API_SENSEDIA_CORP: "apicorp.algartelecom.com.br",
  API_SENSEDIA_BASIC:
    "Basic MjQ3NDcxZTQtMDU0ZS0zNTk3LWFjZjAtYjVmYjI1MGUzNmMzOmE5ZWIwNTAxLTMwYWUtMzgxOS1hZWZlLTkyODFhMGFmYzFlMA==",
  API_SHARED_DATA: "https://compartilhamento.algar.com.br/callback",
  API_CUSTOMER_IDENTITY: "https://customeridentity.algar.com.br/auth",
  SVA_LINK: "https://me.algar.atendimentosva.com.br",
  SVA_DATA:
    '{ "username": "algarppaapi", "password": "z9fQFWtbrXFkHQvFdwjCUaaWsmnwY36cdGBDgPvj", "grant_type": "password", "scope": "read" }',
  BFF: "https://gateway.algartelecom.com.br",
  URL_NEW_B2B: "https://portaldeclientes.algar.com.br"
}

const config = process.env.REACT_APP_STAGE === "production" ? prd : dev

export default {
  ...config
}



// WEBPACK FOOTER //
// ./src/envProperties.js